import { render, staticRenderFns } from "./SummaryReports.vue?vue&type=template&id=c8932078&scoped=true"
import script from "./SummaryReports.vue?vue&type=script&lang=js"
export * from "./SummaryReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8932078",
  null
  
)

export default component.exports